<template>
<card @click="click" class="refCard">
<article class="media">
  <figure class="media-left">
    <div class="imageWrapper">
      <div class="image is-40x40 is-circular" >
        <img v-if="imageUrl" :src="imageUrl">
      </div>
      <div v-if="refImgUrl" class="refImage image is-16x16 is-circular" v-tooltip="{content: tooltip, show: tooltipActive}" @mouseover="tooltipMouseover" @mouseout="tooltipMouseout">
        <img :src="refImgUrl" />
      </div>
    </div>
  </figure>
  <div class="media-content">
    <div class="content left" :class="[!hasContentInRightSlot? 'is-fullwidth': '']">
      <strong class="content-title" v-if="leftTitle">{{ leftTitle }}</strong>
      <slot name="leftTitle" v-else></slot>
      <span v-if="leftSubtitle" class="content-subtitle">{{ leftSubtitle }}</span>
      <slot name="leftSubtitle" v-else></slot>
    </div>
    <div class="content has-text-right">
      <strong v-if="rightTitle">{{ rightTitle }}</strong>
      <slot name="rightTitle" v-else></slot>
      <!-- to adjust the spacing -->
      <strong v-if="!hasContentInRightTitleSlot"></strong>
      <span v-if="rightSubtitle" class="content-subtitle">{{ rightSubtitle }}</span>
      <slot name="rightSubtitle" v-else></slot>
    </div>
  </div>
</article>
</card>
</template>

<script>
import Card from '@/components/general/card'
export default {
  components: {
    Card
  },
  props: {
    imageUrl: {
      type: String,
      required: false
    },
    refImgUrl: {
      type: String,
      required: false
    },
    tooltip: {
      type: String,
      required: false
    },
    leftTitle: {
      type: String,
      required: false
    },
    rightTitle: {
      type: String,
      required: false
    },
    leftSubtitle: {
      type: String,
      required: false
    },
    rightSubtitle: {
      type: String,
      required: false
    }
  },
  computed: {
    hasContentInRightSlot () {
      if (this.rightTitle || this.rightSubtitle) {
        return true
      } else if (this.$slots.rightTitle || this.$slots.rightSubtitle) {
        return true
      }
      return false
    },
    hasContentInRightTitleSlot () {
      if (this.rightTitle || this.$slots.rightTitle) {
        return true
      }
      return false
    }
  },
  data: function () {
    return {
      tooltipActive: false
    }
  },
  methods: {
    tooltipMouseover: function () {
      this.tooltipActive = false
    },
    tooltipMouseout: function () {
      this.tooltipActive = true
    },
    click () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

strong {
  color: $black;
}

.refCard {
  max-height: 72px;
}

.content {
  max-width: 35vw;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.content-subtitle, .content-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.media-content {
  height: 100%;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
}

.media div.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 0;
  height: 100%;
  height: 40px;
}
.is-fullwidth {
  max-width: 100%;
}

.imageWrapper {
  width: 40px;
  position: relative;
  .refImage {
    position: absolute;
    top: 0px;
    right: 0px;
    border: 1px solid #fff;
    background: #fff;
  }
}

@media screen and (max-width: $tablet) {
  .content {
    max-width: none;
  }
  .content.left {
    margin-right: 4px;
    max-width: 60%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/general/referrer-user-row-card.vue